import Button from './button';

export default (props) => {
    const { children } = props;

    return <Button { ...props } className="button--create" icon='create'>{ children ? children : 'Create' }</Button>
}